// extracted by mini-css-extract-plugin
export var clickableHeaderContent = "_ff-0";
export var headerCellHover = "_ff-1";
export var readCellContainer = "_ff-2";
export var unreadIndicator = "_ff-3";